var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 990 720"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EK37"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK37",
    className: "cls-2",
    x: 193,
    y: 105,
    width: 33,
    height: 66
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "EK38"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "EK38",
    className: "cls-2",
    points: "226 130.09 260 130 260 196 226 196 226 130.09"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "EK39"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK39",
    className: "cls-2",
    x: 272,
    y: 130,
    width: 33,
    height: 66
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "EK40"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK40",
    className: "cls-2",
    x: 305,
    y: 130,
    width: 33,
    height: 66
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "EK41"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK41",
    className: "cls-2",
    x: 360,
    y: 130,
    width: 33,
    height: 66
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "EK42"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK42",
    className: "cls-2",
    x: 393,
    y: 130,
    width: 34,
    height: 66
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "EK43"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK43",
    className: "cls-2",
    x: 546,
    y: 130,
    width: 48,
    height: 66
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "EK44"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK44",
    className: "cls-2",
    x: 606,
    y: 130,
    width: 33,
    height: 66
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "EK45"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK45",
    className: "cls-2",
    x: 639,
    y: 130,
    width: 33,
    height: 66
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "EK46"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK46",
    className: "cls-2",
    x: 685,
    y: 130,
    width: 33,
    height: 66
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "EK47"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK47",
    className: "cls-2",
    x: 718,
    y: 130,
    width: 33,
    height: 66
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "EK48"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK48",
    className: "cls-2",
    x: 859,
    y: 261,
    width: 33,
    height: 66
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "EK49"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK49",
    className: "cls-2",
    x: 826,
    y: 261,
    width: 33,
    height: 66
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "EK50"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK50",
    className: "cls-2",
    x: 769,
    y: 261,
    width: 33,
    height: 66
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "EK51"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK51",
    className: "cls-2",
    x: 723,
    y: 261,
    width: 33,
    height: 66
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "EK52"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK52",
    className: "cls-2",
    x: 690,
    y: 261,
    width: 33,
    height: 66
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "EK53"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK53",
    className: "cls-2",
    x: 640,
    y: 261,
    width: 32,
    height: 66
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "EK54"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK54",
    className: "cls-2",
    x: 606,
    y: 261,
    width: 34,
    height: 66
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "EK55"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK55",
    className: "cls-2",
    x: 556,
    y: 261,
    width: 33,
    height: 66
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "EK56"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK56",
    className: "cls-2",
    x: 523,
    y: 261,
    width: 33,
    height: 66
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "EK57"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK57",
    className: "cls-2",
    x: 473,
    y: 261,
    width: 33,
    height: 66
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "EK58"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK58",
    className: "cls-2",
    x: 439,
    y: 261,
    width: 34,
    height: 66
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "EK59"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK59",
    className: "cls-2",
    x: 389,
    y: 261,
    width: 33,
    height: 66
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "EK60"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK60",
    className: "cls-2",
    x: 356,
    y: 261,
    width: 33,
    height: 66
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "EK61"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK61",
    className: "cls-2",
    x: 306,
    y: 261,
    width: 32,
    height: 66
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "EK62"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK62",
    className: "cls-2",
    x: 272,
    y: 261,
    width: 34,
    height: 66
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "EK63"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK63",
    className: "cls-2",
    x: 256,
    y: 405,
    width: 66,
    height: 32
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "EK64"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK64",
    className: "cls-2",
    x: 256,
    y: 437,
    width: 66,
    height: 33
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "EK65"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK65",
    className: "cls-2",
    x: 256,
    y: 470,
    width: 66,
    height: 33
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "EK66"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK66",
    className: "cls-2",
    x: 256,
    y: 510,
    width: 66,
    height: 33
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "EK67"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK67",
    className: "cls-2",
    x: 256,
    y: 543,
    width: 66,
    height: 32
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "EK68"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK68",
    className: "cls-2",
    x: 256,
    y: 575,
    width: 66,
    height: 34
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "EK69"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK69",
    className: "cls-2",
    x: 125,
    y: 576,
    width: 66,
    height: 33
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "EK70"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK70",
    className: "cls-2",
    x: 125,
    y: 544,
    width: 66,
    height: 32
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "EK71"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK71",
    className: "cls-2",
    x: 125,
    y: 510,
    width: 66,
    height: 34
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "EK72"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK72",
    className: "cls-2",
    x: 125,
    y: 471,
    width: 66,
    height: 32
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "EK73"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK73",
    className: "cls-2",
    x: 125,
    y: 438,
    width: 66,
    height: 33
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "EK74"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK74",
    className: "cls-2",
    x: 125,
    y: 405,
    width: 66,
    height: 33
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "EK75"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK75",
    className: "cls-2",
    x: 125,
    y: 355,
    width: 66,
    height: 32
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "EK76"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK76",
    className: "cls-2",
    x: 125,
    y: 321,
    width: 66,
    height: 34
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "EK77"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "EK77",
    className: "cls-2",
    x: 125,
    y: 234,
    width: 67,
    height: 32
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "EK78"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "EK78",
    className: "cls-2",
    points: "125 200 192 201 192 234 125 234 125 200"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5OTAgNzIwIj4KICA8ZyBpZD0iRUszNyI+CiAgICA8cmVjdCBkYXRhLWlkPSJFSzM3IiBjbGFzcz0iY2xzLTIiIHg9IjE5MyIgeT0iMTA1IiB3aWR0aD0iMzMiIGhlaWdodD0iNjYiIC8+CiAgPC9nPgogIDxnIGlkPSJFSzM4Ij4KICAgIDxwb2x5Z29uCiAgICAgIGRhdGEtaWQ9IkVLMzgiCiAgICAgIGNsYXNzPSJjbHMtMiIKICAgICAgcG9pbnRzPSIyMjYgMTMwLjA5IDI2MCAxMzAgMjYwIDE5NiAyMjYgMTk2IDIyNiAxMzAuMDkiCiAgICAvPgogIDwvZz4KICA8ZyBpZD0iRUszOSI+CiAgICA8cmVjdCBkYXRhLWlkPSJFSzM5IiBjbGFzcz0iY2xzLTIiIHg9IjI3MiIgeT0iMTMwIiB3aWR0aD0iMzMiIGhlaWdodD0iNjYiIC8+CiAgPC9nPgogIDxnIGlkPSJFSzQwIj4KICAgIDxyZWN0IGRhdGEtaWQ9IkVLNDAiIGNsYXNzPSJjbHMtMiIgeD0iMzA1IiB5PSIxMzAiIHdpZHRoPSIzMyIgaGVpZ2h0PSI2NiIgLz4KICA8L2c+CiAgPGcgaWQ9IkVLNDEiPgogICAgPHJlY3QgZGF0YS1pZD0iRUs0MSIgY2xhc3M9ImNscy0yIiB4PSIzNjAiIHk9IjEzMCIgd2lkdGg9IjMzIiBoZWlnaHQ9IjY2IiAvPgogIDwvZz4KICA8ZyBpZD0iRUs0MiI+CiAgICA8cmVjdCBkYXRhLWlkPSJFSzQyIiBjbGFzcz0iY2xzLTIiIHg9IjM5MyIgeT0iMTMwIiB3aWR0aD0iMzQiIGhlaWdodD0iNjYiIC8+CiAgPC9nPgogIDxnIGlkPSJFSzQzIj4KICAgIDxyZWN0IGRhdGEtaWQ9IkVLNDMiIGNsYXNzPSJjbHMtMiIgeD0iNTQ2IiB5PSIxMzAiIHdpZHRoPSI0OCIgaGVpZ2h0PSI2NiIgLz4KICA8L2c+CiAgPGcgaWQ9IkVLNDQiPgogICAgPHJlY3QgZGF0YS1pZD0iRUs0NCIgY2xhc3M9ImNscy0yIiB4PSI2MDYiIHk9IjEzMCIgd2lkdGg9IjMzIiBoZWlnaHQ9IjY2IiAvPgogIDwvZz4KICA8ZyBpZD0iRUs0NSI+CiAgICA8cmVjdCBkYXRhLWlkPSJFSzQ1IiBjbGFzcz0iY2xzLTIiIHg9IjYzOSIgeT0iMTMwIiB3aWR0aD0iMzMiIGhlaWdodD0iNjYiIC8+CiAgPC9nPgogIDxnIGlkPSJFSzQ2Ij4KICAgIDxyZWN0IGRhdGEtaWQ9IkVLNDYiIGNsYXNzPSJjbHMtMiIgeD0iNjg1IiB5PSIxMzAiIHdpZHRoPSIzMyIgaGVpZ2h0PSI2NiIgLz4KICA8L2c+CiAgPGcgaWQ9IkVLNDciPgogICAgPHJlY3QgZGF0YS1pZD0iRUs0NyIgY2xhc3M9ImNscy0yIiB4PSI3MTgiIHk9IjEzMCIgd2lkdGg9IjMzIiBoZWlnaHQ9IjY2IiAvPgogIDwvZz4KICA8ZyBpZD0iRUs0OCI+CiAgICA8cmVjdCBkYXRhLWlkPSJFSzQ4IiBjbGFzcz0iY2xzLTIiIHg9Ijg1OSIgeT0iMjYxIiB3aWR0aD0iMzMiIGhlaWdodD0iNjYiIC8+CiAgPC9nPgogIDxnIGlkPSJFSzQ5Ij4KICAgIDxyZWN0IGRhdGEtaWQ9IkVLNDkiIGNsYXNzPSJjbHMtMiIgeD0iODI2IiB5PSIyNjEiIHdpZHRoPSIzMyIgaGVpZ2h0PSI2NiIgLz4KICA8L2c+CiAgPGcgaWQ9IkVLNTAiPgogICAgPHJlY3QgZGF0YS1pZD0iRUs1MCIgY2xhc3M9ImNscy0yIiB4PSI3NjkiIHk9IjI2MSIgd2lkdGg9IjMzIiBoZWlnaHQ9IjY2IiAvPgogIDwvZz4KICA8ZyBpZD0iRUs1MSI+CiAgICA8cmVjdCBkYXRhLWlkPSJFSzUxIiBjbGFzcz0iY2xzLTIiIHg9IjcyMyIgeT0iMjYxIiB3aWR0aD0iMzMiIGhlaWdodD0iNjYiIC8+CiAgPC9nPgogIDxnIGlkPSJFSzUyIj4KICAgIDxyZWN0IGRhdGEtaWQ9IkVLNTIiIGNsYXNzPSJjbHMtMiIgeD0iNjkwIiB5PSIyNjEiIHdpZHRoPSIzMyIgaGVpZ2h0PSI2NiIgLz4KICA8L2c+CiAgPGcgaWQ9IkVLNTMiPgogICAgPHJlY3QgZGF0YS1pZD0iRUs1MyIgY2xhc3M9ImNscy0yIiB4PSI2NDAiIHk9IjI2MSIgd2lkdGg9IjMyIiBoZWlnaHQ9IjY2IiAvPgogIDwvZz4KICA8ZyBpZD0iRUs1NCI+CiAgICA8cmVjdCBkYXRhLWlkPSJFSzU0IiBjbGFzcz0iY2xzLTIiIHg9IjYwNiIgeT0iMjYxIiB3aWR0aD0iMzQiIGhlaWdodD0iNjYiIC8+CiAgPC9nPgogIDxnIGlkPSJFSzU1Ij4KICAgIDxyZWN0IGRhdGEtaWQ9IkVLNTUiIGNsYXNzPSJjbHMtMiIgeD0iNTU2IiB5PSIyNjEiIHdpZHRoPSIzMyIgaGVpZ2h0PSI2NiIgLz4KICA8L2c+CiAgPGcgaWQ9IkVLNTYiPgogICAgPHJlY3QgZGF0YS1pZD0iRUs1NiIgY2xhc3M9ImNscy0yIiB4PSI1MjMiIHk9IjI2MSIgd2lkdGg9IjMzIiBoZWlnaHQ9IjY2IiAvPgogIDwvZz4KICA8ZyBpZD0iRUs1NyI+CiAgICA8cmVjdCBkYXRhLWlkPSJFSzU3IiBjbGFzcz0iY2xzLTIiIHg9IjQ3MyIgeT0iMjYxIiB3aWR0aD0iMzMiIGhlaWdodD0iNjYiIC8+CiAgPC9nPgogIDxnIGlkPSJFSzU4Ij4KICAgIDxyZWN0IGRhdGEtaWQ9IkVLNTgiIGNsYXNzPSJjbHMtMiIgeD0iNDM5IiB5PSIyNjEiIHdpZHRoPSIzNCIgaGVpZ2h0PSI2NiIgLz4KICA8L2c+CiAgPGcgaWQ9IkVLNTkiPgogICAgPHJlY3QgZGF0YS1pZD0iRUs1OSIgY2xhc3M9ImNscy0yIiB4PSIzODkiIHk9IjI2MSIgd2lkdGg9IjMzIiBoZWlnaHQ9IjY2IiAvPgogIDwvZz4KICA8ZyBpZD0iRUs2MCI+CiAgICA8cmVjdCBkYXRhLWlkPSJFSzYwIiBjbGFzcz0iY2xzLTIiIHg9IjM1NiIgeT0iMjYxIiB3aWR0aD0iMzMiIGhlaWdodD0iNjYiIC8+CiAgPC9nPgogIDxnIGlkPSJFSzYxIj4KICAgIDxyZWN0IGRhdGEtaWQ9IkVLNjEiIGNsYXNzPSJjbHMtMiIgeD0iMzA2IiB5PSIyNjEiIHdpZHRoPSIzMiIgaGVpZ2h0PSI2NiIgLz4KICA8L2c+CiAgPGcgaWQ9IkVLNjIiPgogICAgPHJlY3QgZGF0YS1pZD0iRUs2MiIgY2xhc3M9ImNscy0yIiB4PSIyNzIiIHk9IjI2MSIgd2lkdGg9IjM0IiBoZWlnaHQ9IjY2IiAvPgogIDwvZz4KICA8ZyBpZD0iRUs2MyI+CiAgICA8cmVjdCBkYXRhLWlkPSJFSzYzIiBjbGFzcz0iY2xzLTIiIHg9IjI1NiIgeT0iNDA1IiB3aWR0aD0iNjYiIGhlaWdodD0iMzIiIC8+CiAgPC9nPgogIDxnIGlkPSJFSzY0Ij4KICAgIDxyZWN0IGRhdGEtaWQ9IkVLNjQiIGNsYXNzPSJjbHMtMiIgeD0iMjU2IiB5PSI0MzciIHdpZHRoPSI2NiIgaGVpZ2h0PSIzMyIgLz4KICA8L2c+CiAgPGcgaWQ9IkVLNjUiPgogICAgPHJlY3QgZGF0YS1pZD0iRUs2NSIgY2xhc3M9ImNscy0yIiB4PSIyNTYiIHk9IjQ3MCIgd2lkdGg9IjY2IiBoZWlnaHQ9IjMzIiAvPgogIDwvZz4KICA8ZyBpZD0iRUs2NiI+CiAgICA8cmVjdCBkYXRhLWlkPSJFSzY2IiBjbGFzcz0iY2xzLTIiIHg9IjI1NiIgeT0iNTEwIiB3aWR0aD0iNjYiIGhlaWdodD0iMzMiIC8+CiAgPC9nPgogIDxnIGlkPSJFSzY3Ij4KICAgIDxyZWN0IGRhdGEtaWQ9IkVLNjciIGNsYXNzPSJjbHMtMiIgeD0iMjU2IiB5PSI1NDMiIHdpZHRoPSI2NiIgaGVpZ2h0PSIzMiIgLz4KICA8L2c+CiAgPGcgaWQ9IkVLNjgiPgogICAgPHJlY3QgZGF0YS1pZD0iRUs2OCIgY2xhc3M9ImNscy0yIiB4PSIyNTYiIHk9IjU3NSIgd2lkdGg9IjY2IiBoZWlnaHQ9IjM0IiAvPgogIDwvZz4KICA8ZyBpZD0iRUs2OSI+CiAgICA8cmVjdCBkYXRhLWlkPSJFSzY5IiBjbGFzcz0iY2xzLTIiIHg9IjEyNSIgeT0iNTc2IiB3aWR0aD0iNjYiIGhlaWdodD0iMzMiIC8+CiAgPC9nPgogIDxnIGlkPSJFSzcwIj4KICAgIDxyZWN0IGRhdGEtaWQ9IkVLNzAiIGNsYXNzPSJjbHMtMiIgeD0iMTI1IiB5PSI1NDQiIHdpZHRoPSI2NiIgaGVpZ2h0PSIzMiIgLz4KICA8L2c+CiAgPGcgaWQ9IkVLNzEiPgogICAgPHJlY3QgZGF0YS1pZD0iRUs3MSIgY2xhc3M9ImNscy0yIiB4PSIxMjUiIHk9IjUxMCIgd2lkdGg9IjY2IiBoZWlnaHQ9IjM0IiAvPgogIDwvZz4KICA8ZyBpZD0iRUs3MiI+CiAgICA8cmVjdCBkYXRhLWlkPSJFSzcyIiBjbGFzcz0iY2xzLTIiIHg9IjEyNSIgeT0iNDcxIiB3aWR0aD0iNjYiIGhlaWdodD0iMzIiIC8+CiAgPC9nPgogIDxnIGlkPSJFSzczIj4KICAgIDxyZWN0IGRhdGEtaWQ9IkVLNzMiIGNsYXNzPSJjbHMtMiIgeD0iMTI1IiB5PSI0MzgiIHdpZHRoPSI2NiIgaGVpZ2h0PSIzMyIgLz4KICA8L2c+CiAgPGcgaWQ9IkVLNzQiPgogICAgPHJlY3QgZGF0YS1pZD0iRUs3NCIgY2xhc3M9ImNscy0yIiB4PSIxMjUiIHk9IjQwNSIgd2lkdGg9IjY2IiBoZWlnaHQ9IjMzIiAvPgogIDwvZz4KICA8ZyBpZD0iRUs3NSI+CiAgICA8cmVjdCBkYXRhLWlkPSJFSzc1IiBjbGFzcz0iY2xzLTIiIHg9IjEyNSIgeT0iMzU1IiB3aWR0aD0iNjYiIGhlaWdodD0iMzIiIC8+CiAgPC9nPgogIDxnIGlkPSJFSzc2Ij4KICAgIDxyZWN0IGRhdGEtaWQ9IkVLNzYiIGNsYXNzPSJjbHMtMiIgeD0iMTI1IiB5PSIzMjEiIHdpZHRoPSI2NiIgaGVpZ2h0PSIzNCIgLz4KICA8L2c+CiAgPGcgaWQ9IkVLNzciPgogICAgPHJlY3QgZGF0YS1pZD0iRUs3NyIgY2xhc3M9ImNscy0yIiB4PSIxMjUiIHk9IjIzNCIgd2lkdGg9IjY3IiBoZWlnaHQ9IjMyIiAvPgogIDwvZz4KICA8ZyBpZD0iRUs3OCI+CiAgICA8cG9seWdvbgogICAgICBkYXRhLWlkPSJFSzc4IgogICAgICBjbGFzcz0iY2xzLTIiCiAgICAgIHBvaW50cz0iMTI1IDIwMCAxOTIgMjAxIDE5MiAyMzQgMTI1IDIzNCAxMjUgMjAwIgogICAgLz4KICA8L2c+Cjwvc3ZnPgo=";
export { SvgP2 as ReactComponent };